import React from "react";
import PropTypes from "prop-types";
import './css/husaria.css';
import {
  Breadcrumb,
  BreadcrumbItem,
} from "reactstrap";

function HusariaHeader({ name, parentName, padding }) {
  return (
    <div className={`${parentName.toLowerCase()}-header`} style={{"padding-bottom": padding}}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="py-4">
                <div className="flex items-center justify-between flex-wrap gap-4">
                    <div className="">
                        <h6 className="fullcalendar-title h2 text-white d-inline-block mb-0">
                            {name}
                        </h6>{" "}
                        <Breadcrumb
                            className="d-none d-md-inline-block ml-lg-4"
                            listClassName="breadcrumb-links breadcrumb-dark"
                        >
                        <BreadcrumbItem>
                            <a href="#pablo" onClick={(e) => e.preventDefault()}>
                                <i className="fas fa-home" />
                            </a>
                        </BreadcrumbItem>
                        <BreadcrumbItem>
                            <a href="#pablo" onClick={(e) => e.preventDefault()}>
                                {parentName}
                            </a>
                        </BreadcrumbItem>
                        <BreadcrumbItem aria-current="page" className="active">
                            {name}
                        </BreadcrumbItem>
                        </Breadcrumb>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

HusariaHeader.propTypes = {
  name: PropTypes.string,
  parentName: PropTypes.string,
  padding: PropTypes.string,
};

export default HusariaHeader;